import ReactDOM from "react-dom/client";
import { ClerkProvider } from '@clerk/react'
 import { dark } from '@clerk/ui/themes'
import App from "./App";
import "./index.css";

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ClerkProvider publishableKey={clerkPubKey} appearance={{theme: dark}}>
        <App />
    </ClerkProvider>
)